export const isProduction = () => {
  return !window.location.host.startsWith("localhost") &&
      !window.location.host.endsWith("thymebook.com");
}

export const getBookingServer = () => {
  const host = window.location.host;
  if (host.startsWith("localhost")) {
    return "http://localhost:8081";
  } else if (host.endsWith("thymebook.com")) {
    return `https://booking-4yoz7avzca-uc.a.run.app`
  } else if (host.endsWith("onkensu.com") || host.endsWith("kensu-prod.web.app")) {
    return `https://booking-1086228175501.us-central1.run.app`
  }

  throw new Error("Unknown host");
}